"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureFlagApiService = void 0;
const apiService_1 = require("../../core/apiService");
const helpers_1 = require("../../core/helpers");
__exportStar(require("./types"), exports);
class FeatureFlagApiService extends apiService_1.ApiServiceModule {
    constructor({ urlBuilder, urlKey, xhr }) {
        super({ urlBuilder, xhr });
        this.do = (params) => __awaiter(this, void 0, void 0, function* () {
            const url = this.urlBuilder.getUrl(this.urlKey, params);
            const { data } = yield this.xhr.GET(url, { params });
            return data;
        });
        this.parse = (featureFlagRequest) => {
            if (Array.isArray(featureFlagRequest)) {
                return featureFlagRequest.reduce((previousValue, currentValue) => {
                    previousValue.set(currentValue.flagName, currentValue.isEnabled);
                    return previousValue;
                }, new Map());
            }
            return new Map();
        };
        this.validate = (featureFlagRequest) => {
            const isValid = (0, helpers_1.isArray)(featureFlagRequest) || (0, helpers_1.isObject)(featureFlagRequest);
            return { ok: isValid };
        };
        this.urlKey = urlKey;
    }
}
exports.FeatureFlagApiService = FeatureFlagApiService;
//# sourceMappingURL=index.js.map